export const cryptoMiddleware =
  ({ getState }) =>
  (next) =>
  async (action) => {
    const isCrypto = !!getState().dashboardConfig?.config?.api?.encryption;
    next({ ...action, isCrypto });
  };
